export const SHIFT_META_KEYS = ['_id_', 'name', 'shift_number'];



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/constants/shift-non-update-keys.ts